import { withDependencies, named } from '@wix/thunderbolt-ioc'
import {
	CurrentRouteInfoSymbol,
	PageFeatureConfigSymbol,
	ViewerModel,
	ViewerModelSym,
	PagesMapSymbol,
} from '@wix/thunderbolt-symbols'
import type { BreadcrumbsPageConfig } from './types'
import { name } from './symbols'
import { ComponentWillMount, ViewerComponent } from 'feature-components'
import { BreadcrumbsProps } from '@wix/thunderbolt-components-native'
import { ICurrentRouteInfo, IPagesMap } from 'feature-router'
import { SeoSiteSymbol, ISeoSiteApi } from 'feature-seo'
import { ITEM_TYPES } from '@wix/advanced-seo-utils/api'
import { getBreadcrumbs } from './getBreadcrumbs'

const breadcrumbsFactory = (
	pageConfig: BreadcrumbsPageConfig,
	pagesMap: IPagesMap,
	viewerModel: ViewerModel,
	currentRouteInfo: ICurrentRouteInfo,
	seoSiteApi: ISeoSiteApi
): ComponentWillMount<ViewerComponent<BreadcrumbsProps>> => {
	return {
		componentTypes: ['Breadcrumbs'],
		componentWillMount: (component) => {
			const breadcrumbs = getBreadcrumbs(
				currentRouteInfo,
				pagesMap,
				viewerModel,
				pageConfig,
				component.getProps()
			)

			if (breadcrumbs) {
				component.updateProps({ breadcrumbs })

				seoSiteApi.setVeloSeoTags({
					itemType: ITEM_TYPES.BREADCRUMBS_COMPONENT,
					itemData: breadcrumbs,
				})
			}
		},
	}
}

export const Breadcrumbs = withDependencies(
	[named(PageFeatureConfigSymbol, name), PagesMapSymbol, ViewerModelSym, CurrentRouteInfoSymbol, SeoSiteSymbol],
	breadcrumbsFactory
)
